module.exports = __webpack_public_path__ + "chatbotinfost/webchat_static/media/raleway-light.391e21a8.ttf";